var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('v-btn',{attrs:{"rounded":"","color":"primary","dark":""}},[_vm._v("Rounded Button")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }